import { useState, useMemo, useCallback, useEffect } from 'react';
import { countBy, mapValues, isEmpty } from 'lodash-es';
import { useStateInRef } from 'seagull';
export function useRowSelection(param) {
    let { items } = param;
    const [selected, setSelected] = useState({});
    const getSelected = useStateInRef(selected);
    const numSelected = useMemo(()=>{
        var _countBy_true;
        return (_countBy_true = countBy(selected).true) !== null && _countBy_true !== void 0 ? _countBy_true : 0;
    }, [
        selected
    ]);
    useEffect(()=>{
        if (!items || isEmpty(getSelected())) return;
        const ids = items.map((item)=>item.id());
        const newSelected = mapValues(getSelected(), (origValue, itemId)=>ids.includes(itemId) ? origValue : false);
        setSelected(newSelected);
    }, [
        items
    ]);
    const onToggleAllSelection = useCallback((selectAll)=>{
        setSelected(items.reduce((acc, item)=>{
            return Object.assign(acc, {
                [item.id()]: selectAll
            });
        }, {}));
    }, [
        items
    ]);
    const getSelectedIds = useCallback(()=>{
        return Object.entries(selected).filter((param)=>{
            let [, isSelected] = param;
            return isSelected;
        }).map((param)=>{
            let [id] = param;
            return id;
        });
    }, [
        selected
    ]);
    const clearSelection = useCallback(()=>{
        setSelected({});
    }, []);
    return {
        selected,
        numSelected,
        setSelected,
        onToggleAllSelection,
        getSelectedIds,
        clearSelection
    };
}
